import { createContext, useContext } from 'react';
import type { ProStudioNodeDataStore } from '@pypestream/pro-studio-collab-client';

import type { CollabSession } from './use-collab-session';

/**
 * The open draft's live collab session, provided by the Workflows editor
 * (`pages/builder.tsx`). `null` while live editing is off. The connection
 * banner and announcer read it here; the table's read and write paths
 * (PSTUDIO-4450 / PSTUDIO-4451) will read the store.
 */
export const CollabSessionContext = createContext<CollabSession | null>(null);

export const useCollabSessionContext = () => useContext(CollabSessionContext);

/** The connected store, or `null` while there is none (legacy draft, connecting, a publish in flight). */
export const useCollabSessionStore = (): ProStudioNodeDataStore | null =>
  useContext(CollabSessionContext)?.store ?? null;
